import React, {useMemo} from "react";
import {useIntl} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import {navFeatureCLick} from "../../../look/lookNavigation/lookFunctions";
import {FeatureGroup} from "../../../../interfaces/FeatureGroup";
import {Feature} from "../../../../interfaces/Feature";
import {useAppSelector} from "../../../../storeHooks";

interface BodyPanelShowerWallFullWallCheckboxProps {
  featureGroup: FeatureGroup & {
    isFullWall: (f?: Feature) => boolean;
  };
}

export default function BodyPanelShowerWallFullWallCheckbox({
                                                              featureGroup
                                                            }: BodyPanelShowerWallFullWallCheckboxProps) {

  const intl = useIntl();

  const canvasCount = useAppSelector(state => state.bathroomVisualizerState.canvasCount);

  const hideComponent = !featureGroup || !featureGroup.isFullWall || !featureGroup.activeFeature
    || !featureGroup.getParent || !featureGroup.getParent().layout || (featureGroup.getParent().layout.type !== 11)
    || featureGroup.partId !== "shower_wall";

  const sameFeatureWithOppositeWall = useMemo(() => {
    if (hideComponent) {
      return null;
    }
    const name1 = featureGroup.activeFeature.getSplittedFeatureName();
    const conditions = featureGroup.getArrayOfConditions();
    const currentWallIsFullWall = featureGroup.isFullWall();
    return featureGroup.features.find(f => {
      return (f.getSplittedFeatureName() === name1) && f.matchesMetaForArrayOfConditions(conditions)
        && (f.dbFeature.id !== featureGroup.activeFeature.dbFeature.id)
        && (currentWallIsFullWall ? !featureGroup.isFullWall(f) : featureGroup.isFullWall(f))
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, hideComponent, canvasCount]);

  if (hideComponent) {
    return null;
  }

  const checkboxClick = () => {

    console.log(featureGroup);
    // console.log("currentColorFeatures", currentColorFeatures);
    // console.log("sameColorFeatures", sameColorFeatures);
    if (!sameFeatureWithOppositeWall) {
      return null
    }

    // Analytics.sendClickEvent(analyticsLabel + !groheSameColorCheckboxApplied);

    navFeatureCLick(sameFeatureWithOppositeWall); // switch between full wall and normal wall
  }

  return (
    <FormControlLabel
      control={
        <Switch
          className="gm-ios-checkbox"
          disabled={!sameFeatureWithOppositeWall}
          disableRipple
          checked={featureGroup.isFullWall()}
          onChange={checkboxClick}
          color="primary"
        />
      }
      label={intl.formatMessage({id: "desktop.nav.fullWall"})}
    />
  )
}
